// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge-module__root--yR1DX {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 4px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}

.Badge-module__variant-default--tqU3f {
  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */
}

.Badge-module__variant-primary--SpHrh {
  background: var(--chaek-color-surface-inverse);
  color: var(--chaek-color-text-inverse);
}

.Badge-module__variant-ghost--DzJBm {
  background: var(--chaek-color-surface-subtle);
  box-shadow: inset 0 0 0 1px var(--chaek-color-border-divider);
  color: var(--chaek-color-text-primary);
}

.Badge-module__variant-ghost--DzJBm.Badge-module__is-reverse--R15DJ {
  background: transparent;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 15%);
  color: #fff;
}

.Badge-module__variant-soft--iwikF {
  background: var(--chaek-color-surface-subtle);
  color: var(--chaek-color-text-accent);
}

.Badge-module__variant-tinted--aetQU {
  background: #fff4df;
  color: var(--chaek-color-text-accent);
}

.Badge-module__variant-subtle--RCT7J {
  background: var(--chaek-color-surface-subtle);
  color: var(--chaek-color-text-source-333333);
}

.Badge-module__variant-secondary--gl7XR {
  border: 1px solid var(--chaek-color-border-divider);
  background: var(--chaek-color-surface-canvas);
  color: var(--chaek-color-text-primary);
}

.Badge-module__size-x-small--AJr54 {
  height: 19px;
  padding: 2px 8px;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: 15px;
}

.Badge-module__size-small--njsLB {
  height: 27px;
  padding: 5px 8px 6px;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.2328px;
}

.Badge-module__size-medium--KKX9L {
  height: 34px;
  padding: 5px 12px 6px;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.2328px;
  border-radius: 15px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Badge/Badge.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,mDAAmD;EACnD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iDAAiD;EACjD,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iDAAiD;EACjD,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 4px;\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.variant-default {\n  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */\n}\n\n.variant-primary {\n  background: var(--chaek-color-surface-inverse);\n  color: var(--chaek-color-text-inverse);\n}\n\n.variant-ghost {\n  background: var(--chaek-color-surface-subtle);\n  box-shadow: inset 0 0 0 1px var(--chaek-color-border-divider);\n  color: var(--chaek-color-text-primary);\n}\n\n.variant-ghost.is-reverse {\n  background: transparent;\n  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 15%);\n  color: #fff;\n}\n\n.variant-soft {\n  background: var(--chaek-color-surface-subtle);\n  color: var(--chaek-color-text-accent);\n}\n\n.variant-tinted {\n  background: #fff4df;\n  color: var(--chaek-color-text-accent);\n}\n\n.variant-subtle {\n  background: var(--chaek-color-surface-subtle);\n  color: var(--chaek-color-text-source-333333);\n}\n\n.variant-secondary {\n  border: 1px solid var(--chaek-color-border-divider);\n  background: var(--chaek-color-surface-canvas);\n  color: var(--chaek-color-text-primary);\n}\n\n.size-x-small {\n  height: 19px;\n  padding: 2px 8px;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: 15px;\n}\n\n.size-small {\n  height: 27px;\n  padding: 5px 8px 6px;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n}\n\n.size-medium {\n  height: 34px;\n  padding: 5px 12px 6px;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n  border-radius: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Badge-module__root--yR1DX`,
	"variant-default": `Badge-module__variant-default--tqU3f`,
	"variant-primary": `Badge-module__variant-primary--SpHrh`,
	"variant-ghost": `Badge-module__variant-ghost--DzJBm`,
	"is-reverse": `Badge-module__is-reverse--R15DJ`,
	"variant-soft": `Badge-module__variant-soft--iwikF`,
	"variant-tinted": `Badge-module__variant-tinted--aetQU`,
	"variant-subtle": `Badge-module__variant-subtle--RCT7J`,
	"variant-secondary": `Badge-module__variant-secondary--gl7XR`,
	"size-x-small": `Badge-module__size-x-small--AJr54`,
	"size-small": `Badge-module__size-small--njsLB`,
	"size-medium": `Badge-module__size-medium--KKX9L`
};
export default ___CSS_LOADER_EXPORT___;
